export enum adminInvoiceTypes {
    FETCH_ADMIN_INVOICE_REQUEST = "FETCH_ADMIN_INVOICE_REQUEST",
    FETCH_ADMIN_INVOICE_SUCCESS = "FETCH_ADMIN_INVOICE_SUCCESS",
    FETCH_ADMIN_INVOICE_FAILURE = "FETCH_ADMIN_INVOICE_FAILURE",
  }